import React, { Component } from "react";
import SettingsContextProvider from "./SettingsContext";
import PageHeader from "../../PageHeader";
import {
  PAGE_HEADERS,
  SETTINGS_PERMISSIONS_WARNING,
  USER_NOT_AUTHORIZED_EDIT,
} from "../../util/Constants";
import SettingsSkeleton from "./SettingsSkeleton";
import SettingsAuthorizationCustomAlert from "../settingsv2/SettingsAuthorizationCustomAlert";
import SettingsPermissionsWarning from "../settingsv2/SettingsPermissionsWarning";
import PermissionsContextProvider from "../../permissions/PermissionsContext";
import CapabilityContextProvider from "../../overview/context/CapabilityContext";
import SsdSettingsContextProvider from "./ssd/SsdSettingsContext";

class Settingsv2 extends Component {
  render() {
    return (
      <SettingsContextProvider>
        <SsdSettingsContextProvider>
          <CapabilityContextProvider>
            <PermissionsContextProvider>
              <PageHeader {...PAGE_HEADERS.SETTINGS} />
              <SettingsAuthorizationCustomAlert
                title={USER_NOT_AUTHORIZED_EDIT}
              />
              <SettingsPermissionsWarning
                banner={SETTINGS_PERMISSIONS_WARNING}
              />
              <SettingsSkeleton />
            </PermissionsContextProvider>
          </CapabilityContextProvider>
        </SsdSettingsContextProvider>
      </SettingsContextProvider>
    );
  }
}

export default Settingsv2;



// WEBPACK FOOTER //
// ./src/components/settings/settingsv2/Settings.js